import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconLoader = createIcon({
  viewBox: '0 0 64 64',
  path: (
    <g fill="none" fillRule="nonzero">
      <path d="M-4-4h72v72H-4z" />
      <path
        fill="#0d47a1"
        d="M.5 32a2.676 2.676 0 1 1 5.353 0c0 14.44 11.706 26.147 26.147 26.147 14.44 0 26.147-11.706 26.147-26.147C58.147 17.56 46.441 5.853 32 5.853A2.676 2.676 0 1 1 32 .5C49.397.5 63.5 14.603 63.5 32S49.397 63.5 32 63.5.5 49.397.5 32z"
      />
    </g>
  ),
});

export default IconLoader;
